import * as React     from 'react';
import PropTypes      from 'prop-types';
import InputComponent from './input-component';

export default class InputContainer extends React.Component {
	constructor(props) {
		super(props);

		const prefixes = props.prefixes ? [].concat(props.prefixes) : [];
		const suffixes = props.suffixes ? [].concat(props.suffixes) : [];
		
		this.state = { prefixes, suffixes }
	}

	render() {
		return (
			<InputComponent
			{...this.props}
			disabled={this.props.disabled || this.props.loading}
			prefixes={this.state.prefixes}
			suffixes={this.state.suffixes}/>
		);
	}
}

InputContainer.propTypes = {
	checked       : PropTypes.bool,
	disabled      : PropTypes.bool,
	id            : PropTypes.string,
	label         : PropTypes.string,
	loading       : PropTypes.bool,
	name          : PropTypes.string,
	onChange      : PropTypes.func,
	placeholder   : PropTypes.string,
	prefixes      : PropTypes.any,
	readOnly      : PropTypes.bool,
	required      : PropTypes.bool,
	suffixes      : PropTypes.any,
	type          : PropTypes.string.isRequired,
	value         : PropTypes.oneOfType([
		PropTypes.bool,
		PropTypes.number,
		PropTypes.string
	])
}


// WEBPACK FOOTER //
// ./src/component/form/input/input-container.js